module.exports = __webpack_public_path__ + "908f6b27a3e2ca1e5d832cf02dc469c9.png";